// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 757 ? "maplibre-gl" : chunkId) + "." + {"144":"4d7fbccb","358":"c10717d1","757":"c1ed3025"}[chunkId] + ".chunk.js";
};